import React from 'react'
import { useValues, useActions } from 'kea'
import I18n from 'lib/i18n'

import logic from '../logic'

export default function SearchForm () {
  const { setSearchInput, submitQuestion } = useActions(logic)
  const { searchInput } = useValues(logic)
  const submitForm = e => {
    e.preventDefault()
    submitQuestion()
  }
  return (
    <div>
      <form onSubmit={submitForm}>
        <input
          id='search-input'
          className='text'
          type='text'
          name='search'
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
          placeholder={I18n.t('main.search.search')}
          aria-label={I18n.t('main.search.search')}
        />
        <input
          className='submit searchsubmit'
          style={{ height: 32, width: 32 }}
          type='submit'
          value={I18n.t('faqs.index.search')}
        />
      </form>
    </div>
  )
}
